import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { useNavigate } from 'react-router';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, InputBase, InputLabel, List, ListItem, ListItemText, MenuItem, Paper, Radio, RadioGroup, Select, Typography } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';

import moment from 'moment';

import { openSnackbar } from '../store/slices/SnackbarSlice';

import { InputSearchButtonsStyle, InputSearchStyle } from '../styles/FormStyle';

import { DialogBuscarAmparo } from './DialogBuscarAmparo';

import { NuevoOficio } from '../connections/tribunal/OficioConnection';
import { ObtenerMateria } from '../connections/catalogos/MateriaConnection';
import { BuscarIrregular } from '../connections/recepcion/IrregularConnection';
import { BuscarExpediente } from '../connections/recepcion/ExpedienteConnection';
import { ObtenerAutoridadesMaterias } from '../connections/catalogos/AutoridadConnection';
import { BuscarExhortoRecibido } from '../connections/recepcion/ExhortoRecibidoConnection';

import { MateriaProps } from '../interfaces/catalogos/MateriaInterface';
import { NuevoOficioParams } from '../interfaces/tribunal/OficioInterface';
import { AutoridadProps } from '../interfaces/catalogos/AutoridadInterface';
import { BuscarAmparoResponse, defaultBuscarAmparo } from '../interfaces/recepcion/AmparoInterface';
import { BuscarIrregularResponse, defaultIrregularResponse } from '../interfaces/recepcion/IrregularInterface';
import { BuscarExpedienteResponse, defaultExpedienteResponse } from '../interfaces/recepcion/ExpedienteInterface';
import { BuscarExhortoRecibidoResponse, defaultExhortoRecibidoResponse } from '../interfaces/recepcion/ExhortoRecibidoInterface';

interface Props {
    openDialog:         boolean;
    handleCloseDialog:  () => void;
}

export const DialogNuevoOficio = ( { openDialog, handleCloseDialog }: Props ) => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [loading, setLoading] = useState( false );

    const [loadingGuardar, setLoadingGuardar] = useState( false );

    const [tipoBusqueda, setTipoBusqueda] = useState<number>( 0 );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [numeroExpediente, setNumeroExpediente] = useState( '' );
    const [expediente, setExpediente] = useState<BuscarExpedienteResponse>( defaultExpedienteResponse );

    const [numeroExhorto, setNumeroExhorto] = useState( '' );
    const [exhortoRecibido, setExhortoRecibido] = useState<BuscarExhortoRecibidoResponse>( defaultExhortoRecibidoResponse );

    const [numeroAmparo, setNumeroAmparo] = useState( '' );
    const [amparo, setAmparo] = useState<BuscarAmparoResponse>( defaultBuscarAmparo );
    const [openDialogBuscarAmparo, setOpenDialogBuscarAmparo] = useState( false );

    const [numeroIrregular, setNumeroIrregular] = useState( '' );
    const [irregular, setIrregular] = useState<BuscarIrregularResponse>( defaultIrregularResponse );

    const seleccionarAmparo = ( amparo: BuscarAmparoResponse ) => {

        setNumeroAmparo( amparo.numeroAmparo ?? '' );
        setAmparo( amparo );

    }

    const handleGenerarOficio = async () => {

        setLoadingGuardar( true );

        const params: NuevoOficioParams = {
            idAmparo: amparo.idAmparo ?? 0,
            idExhortoRecibido: exhortoRecibido.idExhortoRecibido ?? 0,
            idExpediente: expediente.idExpediente ?? 0,
            idIrregular: irregular.idIrregular ?? 0,
            idTipoOficio: tipoBusqueda
        };

        await NuevoOficio( params ).then( resp => {

            setTimeout(() => {

                const { message, success, idOficio } = resp;

                if( success ){

                    setLoadingGuardar( false );
                    navigate( `/Tribunal/Oficio/elaborar/${ idOficio }` );

                }
                else{

                    setLoadingGuardar( false );
                    dispatch( openSnackbar({ message, variant: 'error' }) );

                }

            }, 700);

        });

    }

    const handleBuscarExpediente = async () => {

        setLoading( true );

        await BuscarExpediente({ numeroExpediente, idAutoridad: autoridad }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if( success ){

                    handleClear();

                    setExpediente( resp );
                    setLoading( false );

                }
                else{

                    handleClear();
                    setLoading( false );

                    dispatch( openSnackbar({ message, variant: 'error' }) );

                }

            }, 700);

        });

    }

    const handleBuscarExhortoRecibido = async () => {

        setLoading( true );

        await BuscarExhortoRecibido({ numeroExhortoRecibido: numeroExhorto, idAutoridad: autoridad }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if( success ){

                    handleClear();

                    setExhortoRecibido( resp );
                    setLoading( false );

                }
                else{

                    handleClear();
                    setLoading( false );

                    dispatch( openSnackbar({ message, variant: 'error' }) );

                }

            }, 700);

        });

    }

    const handleBuscarIrregular = async () => {

        setLoading( true );

        await BuscarIrregular({ numeroIrregular: numeroIrregular, idAutoridad: autoridad }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if( success ){

                    handleClear();

                    setIrregular( resp );
                    setLoading( false );

                }
                else{

                    handleClear();
                    setLoading( false );

                    dispatch( openSnackbar({ message, variant: 'error' }) );

                }

            }, 700);

        });

    }

    const handleClear = () => {

        setMateria( 0 );
        setAutoridad( 0 );
        setAutoridadArray( [] );

        setNumeroExpediente( '' );
        setExpediente( defaultExpedienteResponse );

        setNumeroExhorto( '' );
        setExhortoRecibido( defaultExhortoRecibidoResponse );

        setNumeroAmparo( '' );
        setAmparo( defaultBuscarAmparo );

        setNumeroIrregular( '' );
        setIrregular( defaultIrregularResponse );

    }

    const handleCerrarDialog = () => {

        handleClear();
        handleCloseDialog();
        setTipoBusqueda( 0 );

    }

    const handleChangeTipoBusqueda = ( value: number ) => {

        setNumeroExpediente( '' );
        setExpediente( defaultExpedienteResponse );

        setNumeroExhorto( '' );
        setExhortoRecibido( defaultExhortoRecibidoResponse );

        setNumeroAmparo( '' );
        setAmparo( defaultBuscarAmparo );

        setNumeroIrregular( '' );
        setIrregular( defaultIrregularResponse );

        if( value === 5 ){

            setMateria( 0 );
            setAutoridad( 0 );
            setAutoridadArray( [] );

        }

        setTipoBusqueda( value );

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then( resp => {
                setMateriaArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setAutoridad( 0 );
            setAutoridadArray( [] );

            await ObtenerAutoridadesMaterias( materia ).then( resp => {
                setAutoridadArray( resp );
            });

        }

        if( materia !== 0 ){
            Obtener();
        }

    }, [ materia ]);

    return (
        <>

            <Dialog open={ openDialog } maxWidth='md' fullWidth>

                <DialogTitle>Nuevo oficio</DialogTitle>

                <DialogContent>

                    <Grid container spacing={3} mt={1}>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <FormControl>

                                <FormLabel>Generar oficio para:</FormLabel>

                                <RadioGroup row>
                                   
                                    <FormControlLabel
                                        label='Expediente'
                                        control={ <Radio checked={ tipoBusqueda === 1 } onChange={ () => handleChangeTipoBusqueda( 1 ) } /> }
                                    />
                            
                                    <FormControlLabel
                                        label='Exhorto recibido'
                                        control={ <Radio checked={ tipoBusqueda === 4 } onChange={ () => handleChangeTipoBusqueda( 4 ) } /> }
                                    />
                            
                                    <FormControlLabel
                                        label='Amparo'
                                        control={ <Radio checked={ tipoBusqueda === 2 } onChange={ () => handleChangeTipoBusqueda( 2 ) } /> }
                                    />
                            
                                    <FormControlLabel
                                        label='Irregular'
                                        control={ <Radio checked={ tipoBusqueda === 3 } onChange={ () => handleChangeTipoBusqueda( 3 ) } /> }
                                    />                               

                                </RadioGroup>

                            </FormControl>

                        </Grid>

                        {
                            tipoBusqueda !== 5
                            &&
                                <Grid size={{ xs: 12, md: 4 }}>

                                    <FormControl required fullWidth>
                                        <InputLabel>Materia</InputLabel>

                                        <Select
                                            label='Materia'
                                            value={ materia }
                                            onChange={ (e) => setMateria( parseInt( e.target.value.toString() ) ) }
                                        >
                                            <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>
                                            {
                                                materiaArray
                                                .filter( (e) => e.idMateria === 5 || e.idMateria === 6 )
                                                .map( (e) => (
                                                    <MenuItem key={e.idMateria} value={e.idMateria}>{ e.descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>
                        }

                        {
                            tipoBusqueda !== 5
                            &&
                                <Grid size={{ xs: 12, md: 8 }}>

                                    <FormControl required fullWidth>
                                        <InputLabel>Autoridad</InputLabel>

                                        <Select
                                            label='Autoridad'
                                            value={ autoridad }
                                            onChange={ (e) => setAutoridad( parseInt( e.target.value.toString() ) ) }
                                            disabled={ materia === 0 }
                                        >
                                            <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>
                                            {
                                                autoridadArray.map( (e) => (
                                                    <MenuItem key={e.idAutoridad} value={e.idAutoridad}>{ e.descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>
                        }

                        {/* ---------------------  Busqueda por expediente  -------------------------------------- */}

                        {
                            tipoBusqueda === 1
                            &&
                                <Grid size={12}>

                                    <Paper component='div' sx={ InputSearchStyle }>

                                        <InputBase
                                            sx={{ ml: 1, flex: 1 }}
                                            placeholder='Buscar por número de expediente'
                                            value={ numeroExpediente }
                                            onChange={ (e) => setNumeroExpediente( e.target.value ) }
                                        />

                                        <Button
                                            type='button'
                                            variant='contained'
                                            size='small'
                                            sx={ InputSearchButtonsStyle }
                                            loading={ loading }
                                            disabled={ autoridad === 0 }
                                            onClick={ handleBuscarExpediente }
                                        >
                                            <SearchIcon />
                                        </Button>

                                    </Paper>

                                </Grid>
                        }

                        {
                            expediente.success
                            &&
                                <>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente: </Typography>}
                                                    secondary={
                                                        expediente.numeroFolio
                                                        ?
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.numeroExpediente } (F. { expediente.numeroFolio }) </Typography>
                                                        :
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.numeroExpediente } </Typography>
                                                    }
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de juicio: </Typography>}
                                                    secondary={<Typography variant='subtitle2' fontWeight={'bold'}> { expediente.tipoJuicio } </Typography>}
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    {
                                        expediente.actores.length !== 0
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>

                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Actor(es): </Typography>}
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            expediente.actores.map( (actor, index) => (
                                                                                <ListItem key={index} sx={{ py: 0, px: 0 }}>
                                                                                    <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight={'bold'}> { actor } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }
                                                                    </List>
                                                                </>
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>

                                            </Grid>
                                    }

                                    {
                                        expediente.demandados.length !== 0
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>

                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Demandado(s): </Typography>}
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            expediente.demandados.map( (demandado, index) => (
                                                                                <ListItem key={index} sx={{ py: 0, px: 0 }}>
                                                                                    <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight={'bold'}> { demandado } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }
                                                                    </List>
                                                                </>
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>

                                            </Grid>
                                    }

                                </>
                        }

                        {/* ---------------------  Busqueda por exhorto recibido  -------------------------------------- */}

                        {
                            tipoBusqueda === 4
                            &&
                                <Grid size={12}>

                                    <Paper component='div' sx={ InputSearchStyle }>

                                        <InputBase
                                            sx={{ ml: 1, flex: 1 }}
                                            placeholder='Buscar por número de exhorto'
                                            value={ numeroExhorto }
                                            onChange={ (e) => setNumeroExhorto( e.target.value ) }
                                        />

                                        <Button
                                            type='button'
                                            variant='contained'
                                            size='small'
                                            sx={ InputSearchButtonsStyle }
                                            loading={ loading }
                                            disabled={ autoridad === 0 }
                                            onClick={ handleBuscarExhortoRecibido }
                                        >
                                            <SearchIcon />
                                        </Button>

                                    </Paper>

                                </Grid>
                        }

                        {
                            exhortoRecibido.success
                            &&
                                <>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de exhorto: </Typography>}
                                                    secondary={
                                                        exhortoRecibido.numeroFolio
                                                        ?
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.numeroExhorto } (F. { exhortoRecibido.numeroFolio }) </Typography>
                                                        :
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.numeroExhorto } </Typography>
                                                    }
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de juicio: </Typography>}
                                                    secondary={<Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.tipoJuicio } </Typography>}
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente de origen: </Typography>}
                                                    secondary={<Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.numeroExpedienteOrigen } </Typography>}
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Autoridad del exhorto: </Typography>}
                                                    secondary={<Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.autoridadExhortoRecibido } </Typography>}
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    {
                                        exhortoRecibido.actores.length !== 0
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>

                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Actor(es): </Typography>}
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            exhortoRecibido.actores.map( (actor, index) => (
                                                                                <ListItem key={index} sx={{ py: 0, px: 0 }}>
                                                                                    <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight={'bold'}> { actor } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }
                                                                    </List>
                                                                </>
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>

                                            </Grid>
                                    }

                                    {
                                        exhortoRecibido.demandados.length !== 0
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>

                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Demandado(s): </Typography>}
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            exhortoRecibido.demandados.map( (demandado, index) => (
                                                                                <ListItem key={index} sx={{ py: 0, px: 0 }}>
                                                                                    <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight={'bold'}> { demandado } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }
                                                                    </List>
                                                                </>
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>

                                            </Grid>
                                    }

                                </>
                        }

                        {/* --------------------------  Busqueda por amparo  ------------------------------------------- */}

                        {
                            tipoBusqueda === 2
                            &&
                                <Grid size={12}>

                                    <Paper component='div' sx={ InputSearchStyle }>

                                        <InputBase
                                            disabled
                                            sx={{ ml: 1, flex: 1 }}
                                            placeholder='Buscar amparo por número auxiliar, número de origen, número de expediente'
                                            value={ numeroAmparo }
                                            onChange={ (e) => setNumeroAmparo( e.target.value ) }
                                        />

                                        <Button
                                            type='button'
                                            variant='contained'
                                            size='small'
                                            sx={ InputSearchButtonsStyle }
                                            disabled={ autoridad === 0 }
                                            onClick={ () => setOpenDialogBuscarAmparo( true ) }
                                        >
                                            <SearchIcon />
                                        </Button>

                                    </Paper>

                                </Grid>
                        }

                        {
                            amparo.success
                            &&
                                <>

                                    <Grid size={{ md: 4, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de auxiliar de amparo: </Typography>}
                                                    secondary={<Typography variant='subtitle2' fontWeight={'bold'}> CAA. { amparo.numeroAmparo } </Typography>}
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    {
                                        amparo.numeroAmparoOrigen
                                        &&
                                            <Grid size={{ md: 4, xs: 12 }}>

                                                <List disablePadding>

                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de amparo: </Typography>}
                                                            secondary={<Typography variant='subtitle2' fontWeight={'bold'}> { amparo.numeroAmparoOrigen } </Typography>}
                                                        />

                                                    </ListItem>

                                                </List>

                                            </Grid>
                                    }

                                    {
                                        amparo.numeroExpediente
                                        &&
                                            <Grid size={{ md: 4, xs: 12 }}>

                                                <List disablePadding>

                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente: </Typography>}
                                                            secondary={<Typography variant='subtitle2' fontWeight={'bold'}> { amparo.numeroExpediente } </Typography>}
                                                        />

                                                    </ListItem>

                                                </List>

                                            </Grid>
                                    }

                                    <Grid size={{ md: 4, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de amparo: </Typography>}
                                                    secondary={<Typography variant='subtitle2' fontWeight={'bold'}> { amparo.tipoAmparo } </Typography>}
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    <Grid size={{ md: 4, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Autoridad del amparo: </Typography>}
                                                    secondary={<Typography variant='subtitle2' fontWeight={'bold'}> { amparo.autoridadAmparo } </Typography>}
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    {
                                        amparo.partes.length !== 0
                                        &&
                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <List disablePadding>

                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Parte(s): </Typography>}
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            amparo.partes.map( ({ persona, tipoParte }, index) => (
                                                                                <ListItem key={index} sx={{ py: 0, px: 0 }}>
                                                                                    <Typography sx={{ color: 'black' }} variant='subtitle2'>
                                                                                        { persona } ({ tipoParte })
                                                                                    </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }
                                                                    </List>
                                                                </>
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>

                                            </Grid>
                                    }

                                </>
                        }

                        {/* -------------------------  Busqueda por irregular  ----------------------------------------- */}

                        {
                            tipoBusqueda === 3
                            &&
                                <Grid size={12}>

                                    <Paper component='div' sx={ InputSearchStyle }>

                                        <InputBase
                                            sx={{ ml: 1, flex: 1 }}
                                            placeholder='Buscar por número de irregular'
                                            value={ numeroIrregular }
                                            onChange={ (e) => setNumeroIrregular( e.target.value ) }
                                        />

                                        <Button
                                            type='button'
                                            variant='contained'
                                            size='small'
                                            sx={ InputSearchButtonsStyle }
                                            loading={ loading }
                                            disabled={ autoridad === 0 }
                                            onClick={ handleBuscarIrregular }
                                        >
                                            <SearchIcon />
                                        </Button>

                                    </Paper>

                                </Grid>
                        }

                        {
                            irregular.success
                            &&
                                <>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de irregular: </Typography>}
                                                    secondary={<Typography variant='subtitle2' fontWeight={'bold'}> { irregular.numeroIrregular } </Typography>}
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Fecha: </Typography>}
                                                    secondary={<Typography variant='subtitle2' fontWeight={'bold'}> { irregular.fecha ? moment( irregular.fecha ).format('DD-MM-YYYY') : '' } </Typography>}
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    {
                                        irregular.numeroExpediente
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>

                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente: </Typography>}
                                                            secondary={<Typography variant='subtitle2' fontWeight={'bold'}> { irregular.numeroExpediente } </Typography>}
                                                        />

                                                    </ListItem>

                                                </List>

                                            </Grid>
                                    }

                                    {
                                        irregular.actores.length !== 0
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>

                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Actor(es): </Typography>}
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            irregular.actores.map( (actor, index) => (
                                                                                <ListItem key={index} sx={{ py: 0, px: 0 }}>
                                                                                    <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight={'bold'}> { actor } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }
                                                                    </List>
                                                                </>
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>

                                            </Grid>
                                    }

                                    {
                                        irregular.demandados.length !== 0
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>

                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Demandado(s): </Typography>}
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            irregular.demandados.map( (demandado, index) => (
                                                                                <ListItem key={index} sx={{ py: 0, px: 0 }}>
                                                                                    <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight={'bold'}> { demandado } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }
                                                                    </List>
                                                                </>
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>

                                            </Grid>
                                    }

                                </>
                        }

                    </Grid>

                </DialogContent>

                <DialogActions>

                    <Button color='secondary' disabled={ loadingGuardar } onClick={ handleCerrarDialog }>Cancelar</Button>

                    <Button
                        variant='contained'
                        loading={ loadingGuardar }
                        onClick={ handleGenerarOficio }
                        disabled={
                            tipoBusqueda === 0 ||
                            ( autoridad === 0 && tipoBusqueda !== 5 && !expediente.success && !exhortoRecibido.success && !amparo.success && !irregular.success ) ||
                            ( tipoBusqueda === 1 && !expediente.success ) ||
                            ( tipoBusqueda === 4 && !exhortoRecibido.success ) ||
                            ( tipoBusqueda === 2 && !amparo.success ) ||
                            ( tipoBusqueda === 3 && !irregular.success )
                        }
                    >
                        Guardar
                    </Button>

                </DialogActions>

            </Dialog>

            <DialogBuscarAmparo
                autoridad={ autoridad }
                openDialog={ openDialogBuscarAmparo }
                seleccionarAmparo={ seleccionarAmparo }
                handleCloseDialog={ () => setOpenDialogBuscarAmparo( false ) }
            />

        </>
    )
}
